import React from 'react';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const LocationFilter = ({ selectedLocation, onLocationChange, locations, showAllLocations }) => {
  const locationOptions = [
    { value: 'all', label: 'All Locations' },
    ...locations?.map(loc => ({
      value: loc?.value,
      label: loc?.label,
      description: `${loc?.activeModules} active modules`
    }))
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center gap-3 mb-4">
        <Icon name="MapPin" size={24} color="var(--color-primary)" />
        <h2 className="text-xl font-semibold text-foreground">Location Filter</h2>
      </div>
      <Select
        label="Select Location"
        description="Filter modules by location"
        options={locationOptions}
        value={selectedLocation}
        onChange={onLocationChange}
        searchable
      />
      {showAllLocations && (
        <div className="mt-4 pt-4 border-t border-border">
          <p className="text-sm font-medium text-foreground mb-3">Location Overview</p>
          <div className="space-y-2">
            {locations?.map((location) => (
              <div key={location?.value} className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">{location?.label}</span>
                <span className="font-medium text-foreground">{location?.activeModules} modules</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LocationFilter;